<template>
    <el-dialog title="新增来访者" :modal="false" top="30px" :visible.sync="isVisitorVisible" width="600px" @close="addVisitorClose">
        <div class="p-2">
            <el-form ref="formRef" :model="form_addvisitor" :rules="rules">
                <el-form-item label="姓名" prop="visitorName">
                    <el-input v-model="form_addvisitor.visitorName" placeholder="请输入姓名" />
                </el-form-item>

                <el-form-item label="生理性别" prop="gender">
                    <el-radio-group v-model="form_addvisitor.gender">
                        <el-radio label="男">男</el-radio>
                        <el-radio label="女">女</el-radio>
                    </el-radio-group>
                </el-form-item>

                <el-form-item label="年龄" prop="age">
                    <el-input v-model="form_addvisitor.age" placeholder="请输入年龄" />
                </el-form-item>

                <el-form-item label="首次访问时间" prop="visitDate">
                    <el-date-picker v-model="form_addvisitor.visitDate" type="datetime" clearable placeholder="选择日期时间" />
                </el-form-item>

                <el-form-item label="联系方式" prop="contact">
                    <el-input v-model="form_addvisitor.contact" placeholder="请输入联系方式" />
                </el-form-item>
                <el-form-item label="主要症状">
                    <el-input v-model="form_addvisitor.symptoms" placeholder="请输入主要症状" />
                </el-form-item>
                <el-form-item label="来访背景关键信息">
                    <el-input type="textarea" :rows="4" v-model="form_addvisitor.backgroundInfo" placeholder="请输入来访背景关键信息" />
                </el-form-item>

                <!-- 按钮 -->
                <div class="flex justify-end">
                    <el-button type="text" @click="closeDialog">取消</el-button>
                    <el-button type="primary" @click="submitAddVisitorForm">提交</el-button>
                </div>
            </el-form>

        </div>
    </el-dialog>
</template>

<script>
    import axios from 'axios';
    import { ref } from 'vue';

    export default {
        props: {
            value: {
                type: Boolean,
                required: true,
            },
        },
        computed: {
            isVisitorVisible: {
                get() {
                    return this.value; // 读取父组件传入的值
                },
                set(val) {
                    this.$emit('input', val); // 触发 input 事件，更新父组件的值
                },
            },
        },
        setup() {
            const formRef = ref(null);
            const form_addvisitor = ref({
                visitorName: '匿名',
                gender: '',
                age: '',
                visitDate: '',
                contact: '',
                backgroundInfo: '',
                symptoms: '',
                useLanguage: '普通话',
            });
            const rules = {
                visitorName: [{ required: true, message: '请输入姓名', trigger: 'blur' }],
                gender: [{ required: true, message: '请选择性别', trigger: 'change' }],
                age: [
                    { required: true, message: '请输入年龄', trigger: 'blur' },
                    { pattern: /^[1-9][0-9]*$/, message: '年龄必须是正整数', trigger: 'blur' }
                ],
                visitDate: [{ required: true, message: '请选择首次访问时间', trigger: 'change' }],
                contact: [
                    { required: true, message: '请输入手机号', trigger: 'blur' },
                    {
                        pattern: /^1[3-9]\d{9}$/,
                        message: '请输入有效的11位手机号（以13-19开头）',
                        trigger: 'blur'
                    }
                ],
            };

            const submitAddVisitorFormCheck = async () => {
                return await formRef.value.validate();
            };

            return {
                formRef,
                form_addvisitor,
                rules,
                submitAddVisitorFormCheck,
            };
        },
        data() {
            return {};
        },
        methods: {
            handleConfirm() {
                this.$emit('addVConfirm', 'addVConfirm');
            },
            closeDialog() {
                this.isVisitorVisible = false;
            },
            handleSelectVisitorChange(value) {
                if (!this.visitorList) {
                    console.error('visitorList is not defined');
                    return;
                }
                let v;
                this.visitorList.forEach(group => {
                    // 筛选当前组中的 vinfos
                    const matchingVinfos = group.vinfos.filter(vinfo => vinfo.visitorName === value);
                    if (matchingVinfos.length > 0) {
                        v = matchingVinfos[0];
                        console.log("====选择匹配========");
                        console.log(v);
                    }
                });
                if (v) {
                    this.form_addvisitor.visitorName = v.visitorName;
                    this.form_addvisitor.age = v.age;
                    this.form_addvisitor.gender = v.gender;
                    this.form_addvisitor.backgroundInfo = v.backgroundInfo;
                    this.form_addvisitor.symptoms = v.symptoms;
                    this.form_addvisitor.contact = v.contact;
                }
            },
            async submitAddVisitorForm() {
                if (!(await this.submitAddVisitorFormCheck())) {
                    return;
                }
                const token = localStorage.getItem('token');
                if (!token) {
                    this.$message.error('请先登录！ ');
                    setTimeout(() => {
                        this.showLogin();
                    }, 2000);
                    return;
                }
                try {
                    const payload = {
                        name: this.form_addvisitor.visitorName,
                        age: this.form_addvisitor.age,
                        gender: this.form_addvisitor.gender,
                        visitDate: this.form_addvisitor.visitDate,
                        contact: this.form_addvisitor.contact,
                        symptoms: this.form_addvisitor.symptoms,
                        backgroundInfo: this.form_addvisitor.backgroundInfo,
                    };

                    const response = await axios.post('/api/visitor/add', payload, {
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': `Bearer ${token}`
                        }
                    });
                    this.$message({
                        message: response.data.message,
                        type: response.data.type
                    });
                    this.isVisitorVisible = false;
                    this.handleConfirm();
                } catch (error) {
                    console.error('add failed:', error);
                    this.$message.error('add visitor failed. Please try again.');
                }
            },
            addVisitorClose() {
                this.form_addvisitor = {
                    visitorName: '匿名',
                    gender: '',
                    age: '',
                    visitDate: '',
                    contact: '',
                    symptoms: '',
                    backgroundInfo: '',
                    useLanguage: '普通话',
                };
            },
        },
    };
</script>

<style>
</style>